<template>
    <el-dialog
            class="detail-dialog-container"
            :visible.sync="applyDialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            width="500px"
            center>
        <div class="dialog-container flex flex-direction padding">
            <div class="dialog-header flex">
                <div class="dialog-title flex-sub">申请服务</div>
                <i class="dialog-close el-icon-close" @click="cancel"></i>
            </div>
            <el-form class="form" :model="ruleForm" :rules="rules" ref="ruleForm">
                <el-form-item prop="content">
                    <el-input v-model="ruleForm.content" placeholder="请输入服务需求留言" type="textarea" resize="none"
                              :autosize="{ minRows: 6, maxRows: 6 }">
                    </el-input>
                </el-form-item>
            </el-form>
            <div class="dialog-operate flex align-center justify-center">
                <el-button class="operate black" @click="cancel">稍后再填</el-button>
                <el-button class="operate" :loading="loading" @click="submitForm('ruleForm')">
                    立即申请
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import {applyServer} from '@/api/member'
    export default {
        name: "noticeDetailDialog",
        props: {
            applyDialogVisible: {
                type: Boolean,
                default: false
            },
            sid: { //详情ID
                type: Number,
            },
        },
        data() {
            return {
                loading:false,
                ruleForm: {
                    content: '',
                },
                rules: {
                    content: [
                        {required: true, message: '请输入服务需求留言', trigger: 'blur'},
                        {min: 5, message: '意见建议至少为 5 个字符', trigger: 'blur'}
                    ]
                },
            }
        },
        created() {
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.applyServer();
                    }
                });
            },
            async applyServer(){
                this.loading = true
                let _data = await applyServer(this.sid,this.ruleForm.content)
                this.loading = false
                if (_data.status === 200) {
                    this.clearContent()
                    this.$message.success(_data.msg)
                    this.$emit('watchState', true)
                }
            },
            cancel() {
                this.clearContent()
                this.$emit('watchState', false)
            },
            clearContent(){
                this.$refs.ruleForm.resetFields()
            },
        },
        watch: {

        }
    }
</script>

<style scoped lang="scss">

    .detail-dialog-container {
        .dialog-container {
            .dialog-header {
                height: 55px;
                .dialog-title {
                    font-size: 18px;
                    font-weight: bold;
                    color: #0a2240;
                    text-align: center;
                }
                .dialog-close {
                    font-size: 21px;
                    color: #0a2240;
                    font-weight: bold;
                    cursor: pointer;
                }
            }
            .dialog-content {
                padding: 40px 80px;
                height: 605px;
                .title {
                    font-size: 24px;
                    font-weight: bold;
                    color: #0a2240;
                    text-align: center;
                }
                .content {
                    margin-top: 38px;
                    overflow-y: scroll;
                    &::-webkit-scrollbar {
                        display: none
                    }
                }
                .time{
                    font-size: 16px;
                    color: #0a2240;
                    margin-top: 16px;
                }
            }
            .dialog-operate {
                margin-top: 20px;
                .operate {
                    width: 200px;
                    height: 40px;
                    border-radius: 20px;
                    font-size: 16px;
                    background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                    linear-gradient(#ff9600, #ff9600);
                    background-blend-mode: normal, normal;
                    color: #ffffff;
                    &.black {
                        background: #0a2240 none;
                    }
                }
                .operate+.operate{
                    margin-left: 80px;
                }
            }
            .dialog-footer {
                height: 40px;
                background-color: #e7eff9;
                padding: 0 20px;
                border-radius: 0 0 10px 10px;
                .content {
                    font-size: 16px;
                    color: #8b9fbe;
                }
            }
        }
    }
</style>
